// Footer Component
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/client';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Badge } from '../components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Alert, AlertDescription } from '../components/ui/alert';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '../components/ui/carousel';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Checkbox } from '../components/ui/checkbox';
import { Menu, X, ShoppingCart, Mail, Phone, MapPin, Star, Users, Award, Shield, Plus, Trash2, Edit, Download, Package, FileText } from 'lucide-react';
function Footer() {
  return (
    <footer className="bg-gradient-to-r from-slate-800 to-slate-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-orange-400">Crescent Traders</h3>
            <p className="text-slate-300">Your trusted partner in quality products and exceptional service.</p>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-orange-400">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-slate-300 hover:text-orange-400 transition-colors">About Us</Link>
              <Link to="/catalogue" className="block text-slate-300 hover:text-orange-400 transition-colors">Catalogue</Link>
              <Link to="/quote" className="block text-slate-300 hover:text-orange-400 transition-colors">Get Quote</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-orange-400">Contact Info</h4>
            <div className="space-y-2 text-slate-300">
              <div className="flex items-center space-x-2">
                <Mail size={16} />
                <span>admin@crescent-traders.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} />
                <span>+91 9897215799</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin size={16} />
                <span>27 Marris Road, Johri Villa, Aligarh - 202001, U.P</span>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-orange-400">Follow Us</h4>
            <p className="text-slate-300">Stay connected for updates and offers.</p>
          </div>
        </div>
        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-slate-400">
          <p>&copy; 2026 Crescent Traders. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
export default Footer;